import template from './template.html'

angular
  .module('contabilidad.buscarimportes')
  .component('contabilidadBuscarimportes', {
    bindings: {
      busqueda: '<',
    },
    template,
    controller: Controller,
  })

Controller.$inject = ['$q', '$catalogos', 'ContabilidasBuscarImportes', '$filter', '$location']

function Controller ($q, $catalogos, ContabilidasBuscarImportes, $filter, $location) {
  var $ctrl = this,
    filter = $filter('filter'),
    cuentasBancarias
  $ctrl.$onInit = $onInit
  $ctrl.filtarCuentas = filtarCuentas
  $ctrl.$onChanges = $onChanges
  $ctrl.buscar = buscar

  function $onInit () {
    $ctrl.empresa = null
    $ctrl.cuentabancaria = null
    $ctrl.cuentasbancarias = []
    $ctrl.$promise = $q.all({
      cuentasBancarias: $catalogos.get('cuentasBancarias'),
      empresas: ContabilidasBuscarImportes.getEmpresas(),
    }).then(function (resolve) {
      cuentasBancarias = resolve.cuentasBancarias
      $ctrl.empresas = resolve.empresas.data
      filtarCuentas()
    })
  }

  function $onChanges (changes) {
    if (changes.busqueda)
      $ctrl.busqueda = {
        empresa: changes.busqueda.currentValue.idempresa || null,
        cuentabancaria: changes.busqueda.currentValue.cuenta || null,
        fechaInicial: changes.busqueda.currentValue.fechaInicial || new Date(),
        fechaFinal: changes.busqueda.currentValue.fechaFinal || new Date(),
        importe: parseFloat(changes.busqueda.currentValue.importe) || null,
      }
  }

  function buscar () {
    $location.search({
      idempresa: $ctrl.busqueda.empresa,
      cuenta: $ctrl.busqueda.cuentabancaria,
      fechaInicial: $ctrl.busqueda.fechaInicial.toYMD(),
      fechaFinal: $ctrl.busqueda.fechaFinal.toYMD(),
      importe: $ctrl.busqueda.importe,
    })
  }

  function filtarCuentas () {
    $ctrl.cuentasbancarias = filter(cuentasBancarias, {
      ID_Cliente: $ctrl.busqueda.empresa,
    })
  }
}





// WEBPACK FOOTER //
// ./src/contabilidad/buscarimportes/components/component.js